import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';
import { parsePublicCampaignMailingAccessDto } from './publicMailingResponseRequest';

/**
 * Lot 6.9C.1 — unauthenticated public mailing resolver.
 * Firestore is never imported. Token is sent only to the callable.
 */
export async function resolvePublicCampaignMailingAccess(token) {
  const fn = httpsCallable(functions, 'resolvePublicCampaignMailingAccess');
  const result = await fn({ token });
  return parsePublicCampaignMailingAccessDto(result?.data || null);
}
